import { useState, useCallback } from "react";
import { AlertColor } from "@mui/material";

interface SnackbarState {
  open: boolean;
  message: string;
  severity: AlertColor;
}

interface UseSnackbarReturn {
  snackbar: SnackbarState;
  showSnackbar: (message: string, severity?: AlertColor) => void;
  handleClose: () => void;
  snackbarProps: {
    open: boolean;
    message: string;
    severity: AlertColor;
    onClose: () => void;
  };
}

export const useSnackbar = (): UseSnackbarReturn => {
  const [snackbar, setSnackbar] = useState<SnackbarState>({
    open: false,
    message: "",
    severity: "success",
  });

  const showSnackbar = useCallback((message: string, severity: AlertColor = "success") => {
    setSnackbar({ open: true, message, severity });
  }, []);

  const handleClose = useCallback(() => {
    setSnackbar(prev => ({ ...prev, open: false }));
  }, []);

  return {
    snackbar,
    showSnackbar,
    handleClose,
    snackbarProps: {
      open: snackbar.open,
      message: snackbar.message,
      severity: snackbar.severity,
      onClose: handleClose,
    },
  };
};

export default useSnackbar;
